import { render } from "./PlansIconBox.vue?vue&type=template&id=df57adba&scoped=true&ts=true"
import script from "./PlansIconBox.vue?vue&type=script&lang=ts"
export * from "./PlansIconBox.vue?vue&type=script&lang=ts"

import "./PlansIconBox.vue?vue&type=style&index=0&id=df57adba&scoped=true&lang=css"

import exportComponent from "/builds/otto-tech/otto-financas-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df57adba"]])

export default __exports__